export default __webpack_public_path__ + "static/media/rouleau_et_plume.5f26a8c3.png";